import { Component as ComponentContainer, SectionSeparator } from '@styles/layout';
import { GuidesComponent } from '@model/content';
import { TravelGuideSideBar } from '@components/guides';

export const SimilarArticlesContainer = ({ destination, ...props }: GuidesComponent) => {
  return (
    <ComponentContainer>
      <SectionSeparator size={100} />
      <TravelGuideSideBar {...props} destinationPath={destination?.path} />
    </ComponentContainer>
  );
};
